import { z } from 'zod';
import { IconNameSchema, IconLabelTupleSchema } from './primitives';

const CTASchema = z.object({
  label: z.string(),
  href: z.string(),
  icon: IconNameSchema,
});

const HeroSchema = z.object({
  eyebrow: z.string(),
  headlinePrefix: z.string(),
  headlineEmphasis: z.string(),
  lead: z.string(),
  ctaPrimary: CTASchema,
  ctaSecondary: CTASchema,
});

const BioSchema = z.object({
  headline: z.string(),
  paragraphs: z.array(z.string()).min(1),
});

const InterestsSchema = z.object({
  eyebrow: z.string(),
  headline: z.string(),
  body: z.string(),
  tags: z.array(IconLabelTupleSchema).min(1),
});

const EraSchema = z.object({
  name: z.string(),
  span: z.string(),
  now: z.boolean().optional(),
});

const SeoSchema = z.object({
  title: z.string(),
  description: z.string(),
  ogImage: z.string().optional(),
});

export const SiteSchema = z.object({
  seo: SeoSchema,
  hero: HeroSchema,
  bio: BioSchema,
  interests: InterestsSchema,
  stats: z.array(z.tuple([z.string(), z.string()])).min(1),
  eras: z.array(EraSchema).min(1),
  links: z.record(z.string(), z.string()),
  pages: z.array(z.tuple([z.string(), z.string()])).min(1),
});

export type Site = z.infer<typeof SiteSchema>;
export type Hero = z.infer<typeof HeroSchema>;
export type Bio = z.infer<typeof BioSchema>;
export type Interests = z.infer<typeof InterestsSchema>;
export type Era = z.infer<typeof EraSchema>;
export type CTA = z.infer<typeof CTASchema>;
